var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "student-view" },
    [
      _c(
        "div",
        { staticClass: "search-wrapper" },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "100px" },
              attrs: { size: "mini", clearable: "", placeholder: "选择班级" },
              on: {
                change: function ($event) {
                  return _vm.handleCurrentChange()
                },
              },
              model: {
                value: _vm.classId,
                callback: function ($$v) {
                  _vm.classId = $$v
                },
                expression: "classId",
              },
            },
            _vm._l(_vm.classList, function (item) {
              return _c("el-option", {
                key: "class-" + item.id,
                attrs: { label: item.className, value: item.id },
              })
            }),
            1
          ),
          _c("el-input", {
            staticStyle: { width: "186px" },
            attrs: {
              size: "mini",
              clearable: "",
              placeholder: "搜索(考号/姓名)",
              "suffix-icon": "el-icon-search",
            },
            on: {
              change: function ($event) {
                return _vm.handleCurrentChange()
              },
            },
            model: {
              value: _vm.keyWord,
              callback: function ($$v) {
                _vm.keyWord = $$v
              },
              expression: "keyWord",
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "tab-list" }, [
        _c(
          "ul",
          { staticClass: "tab-item" },
          _vm._l(_vm.studentTypeList, function (item, index) {
            return _c(
              "li",
              {
                key: "tab" + index,
                style: { background: _vm.tabIdx == item.type ? "#ffffff" : "" },
                on: {
                  click: function ($event) {
                    return _vm.handleChangeType(item.type)
                  },
                },
              },
              [
                _vm._v(
                  " " + _vm._s(item.name) + "（" + _vm._s(item.total) + "） "
                ),
              ]
            )
          }),
          0
        ),
      ]),
      _c("div", { staticClass: "scan-paper-content" }, [
        _c(
          "div",
          { staticClass: "content-wrapper" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticStyle: { width: "100%" },
                attrs: { data: _vm.list, size: "medium", border: "" },
                on: { "selection-change": _vm.handleSelectionChange },
              },
              [
                _vm.isDelete
                  ? _c("el-table-column", {
                      attrs: {
                        align: "center",
                        type: "selection",
                        width: "55",
                      },
                    })
                  : _vm._e(),
                _c("el-table-column", {
                  attrs: { align: "center", prop: "className", label: "班级" },
                }),
                _c("el-table-column", {
                  attrs: { align: "center", prop: "studNo", label: "学号" },
                }),
                _c("el-table-column", {
                  attrs: { align: "center", prop: "examNo", label: "考号" },
                }),
                _c("el-table-column", {
                  attrs: { align: "center", prop: "studName", label: "姓名" },
                }),
                _vm.showSchool
                  ? _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "totScore",
                        label: "总分",
                      },
                    })
                  : _vm._e(),
                _vm.showSchool
                  ? _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "objScore",
                        label: "客观题",
                      },
                    })
                  : _vm._e(),
                _vm.showSchool
                  ? _c("el-table-column", {
                      attrs: {
                        align: "center",
                        prop: "subScore",
                        label: "主观题",
                      },
                    })
                  : _vm._e(),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    label: "参与统计",
                    "render-header": _vm.renderHeader,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.amentiaReason
                            ? [
                                _c("span", [
                                  _vm._v(" " + _vm._s(scope.row.amentiaReason)),
                                ]),
                              ]
                            : _vm.tabIdx <= 1 && scope.row.status == 1
                            ? _c(
                                "span",
                                [
                                  _vm.isPermission
                                    ? _c("el-switch", {
                                        attrs: {
                                          "active-value": 1,
                                          "inactive-value": 0,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.handleCountSwitch(
                                              scope.row.id
                                            )
                                          },
                                        },
                                        model: {
                                          value: scope.row.amentiaFlag,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "amentiaFlag",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.amentiaFlag",
                                        },
                                      })
                                    : _c("el-switch", {
                                        attrs: {
                                          disabled: true,
                                          "active-value": 1,
                                          "inactive-value": 0,
                                        },
                                        model: {
                                          value: scope.row.amentiaFlag,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "amentiaFlag",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.amentiaFlag",
                                        },
                                      }),
                                ],
                                1
                              )
                            : _c("span", [
                                _vm._v(
                                  _vm._s(scope.row.amentiaFlag ? "是" : "否")
                                ),
                              ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { align: "center", label: "操作", width: "200" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "edit-list" },
                            [
                              scope.row.wayFlag !== 2
                                ? [
                                    scope.row.wayFlag === 1
                                      ? _c(
                                          "p",
                                          [
                                            _vm.isPermission
                                              ? _c(
                                                  "span",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.setDistinguishMark(
                                                          scope.row,
                                                          5
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("删除")]
                                                )
                                              : _c(
                                                  "el-link",
                                                  { attrs: { disabled: "" } },
                                                  [_vm._v("删除")]
                                                ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    scope.row.status == 0
                                      ? _c(
                                          "p",
                                          [
                                            _vm.isPermission
                                              ? _c(
                                                  "span",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.recordScore(
                                                          scope.row,
                                                          0
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("编辑")]
                                                )
                                              : _c(
                                                  "el-link",
                                                  { attrs: { disabled: "" } },
                                                  [_vm._v("编辑")]
                                                ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm._e(),
                              scope.row.flag === 0 || scope.row.flag === 3
                                ? _c("p", [
                                    _c(
                                      "span",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.recordScore(scope.row, 1)
                                          },
                                        },
                                      },
                                      [_vm._v("编辑")]
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "list-bottom" },
          [
            _vm.isDelete
              ? _c(
                  "div",
                  { staticStyle: { float: "left" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "danger",
                          size: "small",
                          disabled: _vm.multipleSelection.length <= 0,
                          plain: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.batchDelete()
                          },
                        },
                      },
                      [_vm._v("批量删除")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", size: "small", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.delTemplate()
                          },
                        },
                      },
                      [_vm._v("删除全部成绩及模板")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c("zj-pagination", {
              attrs: {
                page: {
                  current: _vm.pagination.current,
                  size: _vm.pagination.pageSize,
                  total: _vm.pagination.total,
                },
              },
              on: { "current-change": _vm.handleCurrentChange },
            }),
          ],
          1
        ),
      ]),
      _c(
        "yue-dialog",
        {
          attrs: {
            "custom-class": "record-dialog",
            title: _vm.currentStudent.studName + " 编辑成绩",
            visible: _vm.dialogFormVisible,
            "close-on-click-modal": false,
            width: "780px",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.recordScoreLoading,
                  expression: "recordScoreLoading",
                },
              ],
              staticStyle: { "min-height": "200px" },
              attrs: { inline: true },
            },
            [
              _c("div", { staticClass: "sub-header" }, [
                _c("span", { staticClass: "horizontal-line" }),
                _c(
                  "span",
                  {
                    staticStyle: { background: "white", "font-weight": "bold" },
                  },
                  [_vm._v("客观题")]
                ),
                _vm.objectiveQuestions.length > 0
                  ? _c(
                      "span",
                      {
                        staticStyle: { float: "right", "font-weight": "bold" },
                      },
                      [_vm._v("客观题总分：" + _vm._s(_vm.objectiveScoreAll))]
                    )
                  : _vm._e(),
              ]),
              _vm.objectiveQuestions.length == 0
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        height: "50px",
                        "line-height": "30px",
                        "text-align": "center",
                        color: "#ccc",
                        "font-weight": "bold",
                      },
                    },
                    [_vm._v(" 无客观题 ")]
                  )
                : _vm._e(),
              _vm._l(_vm.objectiveQuestions, function (item) {
                return _c(
                  "el-form-item",
                  {
                    key: "objective" + item.question,
                    attrs: {
                      label:
                        item.bigNum && item.smallNum
                          ? item.bigNum + "." + item.smallNum
                          : item.question,
                    },
                  },
                  [
                    _c("el-input", {
                      class: item.score > item.point ? "colorRed" : "",
                      attrs: {
                        "auto-complete": "off",
                        maxlength: 4,
                        placeholder: "得分",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.isNumFunc(
                            item.score,
                            item.point,
                            "objective"
                          )
                        },
                      },
                      model: {
                        value: item.score,
                        callback: function ($$v) {
                          _vm.$set(item, "score", $$v)
                        },
                        expression: "item.score",
                      },
                    }),
                  ],
                  1
                )
              }),
              _c("div", { staticClass: "sub-header" }, [
                _c("span", { staticClass: "horizontal-line" }),
                _c(
                  "span",
                  {
                    staticStyle: { background: "white", "font-weight": "bold" },
                  },
                  [_vm._v("主观题")]
                ),
                _vm.subjectiveQuestions.length > 0
                  ? _c(
                      "span",
                      {
                        staticStyle: { float: "right", "font-weight": "bold" },
                      },
                      [_vm._v("主观题总分：" + _vm._s(_vm.subjectiveScoreAll))]
                    )
                  : _vm._e(),
              ]),
              _vm.subjectiveQuestions.length == 0
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "center",
                        color: "#ccc",
                        "font-weight": "bold",
                      },
                    },
                    [_vm._v(" 无主观题 ")]
                  )
                : _vm._e(),
              _vm._l(_vm.subjectiveQuestions, function (item) {
                return _c(
                  "el-form-item",
                  {
                    key: "subjective" + item.question,
                    staticStyle: {
                      "text-align": "left",
                      "line-height": "20px",
                      padding: "10px 0",
                      "vertical-align": "baseline",
                    },
                    attrs: {
                      label:
                        item.bigNum && item.smallNum
                          ? item.bigNum + "." + item.smallNum
                          : item.question,
                    },
                  },
                  [
                    _c("el-input", {
                      class: item.score > item.point ? "colorRed" : "",
                      attrs: {
                        "auto-complete": "off",
                        maxlength: 4,
                        placeholder: "得分",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.isNumFunc(
                            item.score,
                            item.point,
                            "subjective"
                          )
                        },
                      },
                      model: {
                        value: item.score,
                        callback: function ($$v) {
                          _vm.$set(item, "score", $$v)
                        },
                        expression: "item.score",
                      },
                    }),
                  ],
                  1
                )
              }),
              _vm.subjectiveQuestions.length > 0 ||
              _vm.objectiveQuestions.length > 0
                ? _c("div", { staticClass: "sub-header" }, [
                    _c(
                      "span",
                      {
                        staticStyle: { float: "right", "font-weight": "bold" },
                      },
                      [
                        _vm._v(
                          "总分：" +
                            _vm._s(
                              _vm.subjectiveScoreAll + _vm.objectiveScoreAll
                            )
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ],
            2
          ),
          _c("template", { slot: "footer" }, [
            _c("span", { staticStyle: { color: "red", "font-size": "14px" } }, [
              _vm._v(
                "请修改完全部成绩后，点击考试列表-更多-重新生成单科报告，生成最新报告"
              ),
            ]),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                staticStyle: { "margin-top": "10px" },
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "medium" },
                    on: {
                      click: function ($event) {
                        _vm.dialogFormVisible = false
                      },
                    },
                  },
                  [_vm._v("取 消")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      size: "medium",
                      type: "primary",
                      loading: _vm.recordScoreBtnLoading,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.updateDistinguishInput()
                      },
                    },
                  },
                  [_vm._v("确 定")]
                ),
              ],
              1
            ),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }